import { Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import { getFinancialYears } from "../../../core/india-map/utils";
export const MONTHS = [
  {
    label: "January",
    value: 1,
  },
  {
    label: "February",
    value: 2,
  },
  {
    label: "March",
    value: 3,
  },
  {
    label: "April",
    value: 4,
  },
  {
    label: "May",
    value: 5,
  },
  {
    label: "June",
    value: 6,
  },
  {
    label: "July",
    value: 7,
  },
  {
    label: "August",
    value: 8,
  },
  {
    label: "September",
    value: 9,
  },
  {
    label: "October",
    value: 10,
  },
  {
    label: "November",
    value: 11,
  },
  {
    label: "December",
    value: 12,
  },
];
export const HeaderConfig = [
  {
    label: "Financial Year",
    id: "financialYear",
  },
  {
    label: "Month",
    id: "month",
    render: (data) => {
      const month = MONTHS?.find((ele) => ele.value === data.month);
      return <span>{month?.label}</span>;
    },
  },
  {
    label: "Actual Man Hours",
    id: "actualManHours",
  },
  {
    label: "Target Man Hours",
    id: "targetManHours",
  },
  {
    label: "Actual Touch Points",
    id: "actualTouchPoints",
  },
  {
    label: "Target Touch Points",
    id: "targetTouchPoints",
  },
  {
    label: "Action",
    id: "action",
    render: (data, onClick) => (
      <Box sx={{ display: "flex" }}>
        <IconButton onClick={() => onClick("EDIT", data)} sx={{ p: 0 }}>
          <EditIcon color="primary" />
        </IconButton>
        <IconButton onClick={() => onClick("DELETE", data)} sx={{ p: 0 }}>
          <DeleteIcon color="error" />
        </IconButton>
      </Box>
    ),
  },
];
export const PERFORMER_TYPE = [
  { label: "Monthly", value: "MONTH" },
  { label: "Yearly", value: "YEAR" },
];
export function generateYearList(startYear = 2020, endYear = 2100) {
  const yearList = [];
  for (let year = startYear; year <= endYear; year++) {
    yearList.push({
      value: year.toString(),
      label: year.toString(),
    });
  }
  return yearList;
}

export const getUserFormConfig = (usersList) => {
  const list = [
    {
      name: "financialYear",
      type: "autocomplete",
      label: "Financial Year",
      options: getFinancialYears(),
      placeholder: "Financial Year",
      required: true,
    },
    {
      name: "month",
      type: "autocomplete",
      label: "Month",
      options: MONTHS,
      placeholder: "Select Month",
      required: true,
    },
    {
      name: "targetManHours",
      type: "number",
      label: "Target Man Hours",
      placeholder: "Target Man Hours",
      required: true,
    },
    {
      name: "targetTouchPoints",
      type: "number",
      label: "Target Touch Points",
      placeholder: "Target Touch Points",
      required: true,
    },
    {
      name: "actualManHours",
      type: "number",
      label: "Actual Man Hours",
      placeholder: "Actual Man Hours",
      required: true,
    },
    {
      name: "actualTouchPoints",
      type: "number",
      label: "Actual Touch Points",
      placeholder: "Actual Touch Points",
      required: true,
    },
  ];

  return list;
};
